import {
  listById,
  moveList,
  renameList,
  required,
  setListEmoji,
  styled,
  ToucanManageRows,
} from "toucan";
import {
  addList,
  deleteList,
  itemsOnList,
  RESERVED_LIST_NAMES,
} from "../model.ts";
import { forgetLibraryList } from "../routes.ts";
import { lists, store } from "../state.ts";
import type { ManageRowActions, ManageRowItem } from "toucan";

const Page = styled("section")`
  padding: 1rem;
  min-height: 100%;
  /* The same warm canvas the library sits on. */
  background: var(--toucan-canvas);
`;

/** The list a row names. Every row is drawn from a list that is there. */
function list(id: string) {
  return required(listById(store().lists, id), "list");
}

/** What a row's controls mean here. */
const actions: ManageRowActions = {
  onRename: (id, name) => {
    renameList(list(id), name);
  },
  onEmoji: (id, emoji) => {
    setListEmoji(list(id), emoji);
  },
  onDelete: (id) => {
    deleteList(store(), id);
    // Leaving here returns to the library view this screen was opened from,
    // and that cannot be a deleted list.
    forgetLibraryList(id);
  },
  onMove: (id, delta) => {
    moveList(store().lists, id, delta);
  },
  onCreate: (name, emoji) => {
    if (emoji === "") {
      addList(store(), name);
      return;
    }
    addList(store(), name, emoji);
  },
};

/**
 * The Manage lists screen: the platform's manage rows, with each list's item
 * count and what each action does to the library.
 */
export function ListsPage() {
  const items: ManageRowItem[] = lists().map((entry) => {
    const item: ManageRowItem = {
      id: entry.id,
      name: entry.name,
      uses: itemsOnList(store(), entry.id).length,
    };
    if (entry.emoji !== undefined) {
      item.emoji = entry.emoji;
    }
    return item;
  });
  return (
    <Page className="page-column">
      <ToucanManageRows
        thing="List"
        noun="article"
        reorder
        items={items}
        actions={actions}
        reserved={RESERVED_LIST_NAMES}
      />
    </Page>
  );
}
